import * as React from 'react';
import useForceUpdate from './useForceUpdate';
export default function useSyncState(initialValue) {
  var ref = React.useRef(initialValue);
  var forceUpdate = useForceUpdate();
  return [function () {
    return ref.current;
  }, function (newValue) {
    ref.current = newValue; // re-render

    forceUpdate();
  }];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/hooks/useSyncState.js
// module id = 1105
// module chunks = 0